import { AxiosError } from 'axios';
import instance from '../config/axios';

export const getProducts = async (accessToken: string) => {
  try {
    const response = await instance({
      method: 'GET',
      url: `/api/v1/fetch/products`,
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    });

    return response.data;
  } catch (e) {
    console.log((e as AxiosError).response);
    return (e as AxiosError).response?.status;
  }
};
